import { CrudeTab } from '@3m5/crude-frontend/dist/shared/types/configurationTypes'

const crudeTabConfig = (): CrudeTab[] => {
  return [
    {
      entity: 'Contact',
    },
    {
      entity: 'Company',
    },
    {
      entity: 'Membership',
    },
    {
      entity: 'Payment',
    },
    {
      entity: 'Participation',
    },
    {
      entity: 'ParticipationFee',
    },
    {
      entity: 'Invoice',
    },
  ]
}
export default crudeTabConfig
